import { Button, Layout, Space } from "antd";
import { useState, useEffect } from "react";
import { CreateWaterJournalDto, WaterJournal, UpdateWaterJournalDto } from "../../api";
import { BASE_PATH } from "../../api/base";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { EditableTable } from "../../components/editable-table/EditableTable";
import { fetchWaterPointsByOrganizationidAsync } from "../waterPoints/WaterPointsSlice";
import { WaterJournalsForm } from "./components/WaterJournalsForm";
import { WaterJournalsColumns } from "./form/columns";
import { createWaterJournalAsync, updateWaterJournalAsync, selectWaterJournals, deleteWaterJournalAsync, fetchWaterJournalsByQuarterAsync } from "./WaterJournalsSlice";
import { WaterJournalForm } from "./components/WaterJournalForm";

interface WaterJournalsComponentProps {
  organizationId?: string;
  year?: number;
  quarter?: number;
}

export const WaterJournalsComponent: React.FC<WaterJournalsComponentProps> = ({ organizationId, year, quarter }) => {
  const dispatch = useAppDispatch();
  const journals = useAppSelector(selectWaterJournals);

  const waterJournals = journals.map((journal) => (
    {
    ...journal,
    point: `№${journal?.pollutant?.point?.no} ${journal?.pollutant?.point?.name} (${journal?.pollutant?.point?.latitude}° ш. ${journal?.pollutant?.point?.longitude}° д.)` || undefined,
  }));

  const [visibleForms, setFormsVisible] = useState(false);
  const [visibleForm, setFormVisible] = useState(false);

  useEffect(() => {
    if (organizationId) {
      if (year && quarter) {
        dispatch(fetchWaterJournalsByQuarterAsync({ organizationId, year, quarter }));
      } else {
        dispatch(fetchWaterJournalsByQuarterAsync({ organizationId, year: new Date().getFullYear(), quarter: Math.ceil(new Date().getMonth() / 3) }));
      }

      dispatch(fetchWaterPointsByOrganizationidAsync(organizationId));
    }
  }, [year, quarter, organizationId, dispatch]);

  const onUpdate = async (waterJournal: UpdateWaterJournalDto, id: string) => {
    return dispatch(updateWaterJournalAsync({ waterJournal, id })).then((res: any) => {
      if (!res.error) {
        if (organizationId) {
          if (year && quarter) {
            dispatch(fetchWaterJournalsByQuarterAsync({ organizationId, year, quarter }));
          } else {
            dispatch(fetchWaterJournalsByQuarterAsync({ organizationId, year: new Date().getFullYear(), quarter: Math.ceil(new Date().getMonth() / 3) }));
          }
        }
        return true;
      }
      return false;
    });
  };

  const onCreateWaterJournal = (waterJournal: CreateWaterJournalDto) => {
    if (!organizationId || !year || !quarter) return;

    dispatch(createWaterJournalAsync({ ...waterJournal, organizationId, year, quarter })).then((res: any) => {
      if (!res.error) {
        setFormVisible(false);
        setFormsVisible(false);
      }
    });
  };

  const deleteWaterJournals = (waterJournal: WaterJournal) => {
    return dispatch(deleteWaterJournalAsync({ waterJournal })).then((res: any) => {
      if (!res.error) {
        return true;
      }
      return false;
    });
  }

  
  const addButtons = (
    <Space direction="vertical" size="middle" style={{ display: 'flex' }}>
      <Button onClick={() => setFormVisible(true)} block type="dashed" className="">
        + Добавить запись в журнал
      </Button>
      <Button onClick={() => setFormsVisible(true)} block type="dashed">
        + Добавить несколько записей в журнал
      </Button>
    </Space>
  )

  return (
    <Layout className="bg-white p-4 rounded-lg">
      {visibleForms && <WaterJournalsForm visible={visibleForms} setVisible={setFormsVisible} onCreateWaterJournal={onCreateWaterJournal} organizationId={organizationId} />}
      {visibleForm && <WaterJournalForm visible={visibleForm} setVisible={setFormVisible} onCreateWaterJournal={onCreateWaterJournal} organizationId={organizationId} />}

      <div className="table-responsive">
        <EditableTable<WaterJournal, UpdateWaterJournalDto>
          onSave={onUpdate}
          onDelete={deleteWaterJournals}
          entityColumns={WaterJournalsColumns()}
          dataSource={waterJournals}
          footer={() => addButtons}
        />
      </div>
      <Button href={`${BASE_PATH}/water-journal/report/organization/${organizationId}`} block type="primary" ghost>
        Получить отчёт
      </Button>
    </Layout>
  );
};
